
























































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import EventBus from '@/plugins/EventBus'
import { onlyNumber } from '@/utils/common'

@Component

export default class ComponentModalBackofficeCaixaCirurgica extends Vue {
  @Prop({ required: true, default: 'solicitacao' }) solicitacao: string
  $refs!: { quantidadeForm: any }

  inputSearch: string = ''
  loadDeleteSelected: string = ''
  quantidadeRules: any = {
    valid: true,
    quantidade: [v => !!v || 'Campo obrigatório.'],
  }

  caixaCirurgica: any = null
  modalQuantidade: boolean = false
  loadSaveCaixaCirurgica: boolean = false

  get getCaixasCirurgicas() {
    return this.getBackofficeGlobalStore.solicitacao.caixasCirurgicas || []
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getCaixasCirurgicasApi() {
    return this.getBackofficeGlobalStore.caixasCirurgicasApi || []
  }

  get showModalCaixaCirurgica() {
    return this.getBackofficeGlobalStore.modal.caixaCirurgica
  }

  set showModalCaixaCirurgica(value: boolean) {
    this.getBackofficeGlobalStore.setModal({ name: 'caixaCirurgica', value })
  }

  get showModalQuantidade() {
    return this.modalQuantidade
  }

  set showModalQuantidade(value: boolean) {
    this.modalQuantidade = value
  }

  get loadingDeleteSelected() {
    return this.loadDeleteSelected
  }

  set loadingDeleteSelected(value: string) {
    this.loadDeleteSelected = value
  }

  get loadingSaveCaixaCirurgica() {
    return this.loadSaveCaixaCirurgica
  }

  set loadingSaveCaixaCirurgica(value: boolean) {
    this.loadSaveCaixaCirurgica = value
  }

  get getInputSearch() {
    return this.inputSearch
  }

  set getInputSearch(value) {
    this.inputSearch = value
  }

  debounce = _.debounce(input => this.getBackofficeGlobalStore.getAllCaixasCirurgicasByHospitalId(input), 600)

  search(input) {
    if (this.inputSearch.length === 0 || this.inputSearch.length > 2) {
      this.debounce(this.inputSearch)
    }
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  addItem(item: any) {
    this.caixaCirurgica = { quantidade: 1, caixaCirurgicaId: item.id, ...item }
    this.showModalQuantidade = true
  }

  async deleteSelected(item: any) {
    this.loadingDeleteSelected = item.id
    const response = await this.getBackofficeGlobalStore.deleteCaixaCirurgicaBySolicitacaoId(item.id)
    if (!response.success) EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao apagar a caixa cirúrgica.', icon: 'warning', color: '#C62828' })
    this.loadingDeleteSelected = ''
  }

  async save() {
    if (!this.$refs.quantidadeForm.validate()) return
    this.loadingSaveCaixaCirurgica = true
    const response = await this.getBackofficeGlobalStore.upsertCaixaCirurgicaBySolicitacaoId(this.caixaCirurgica)
    if (!response.success) EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao adicionar a caixa cirúrgica.', icon: 'warning', color: '#C62828' })
    this.loadingSaveCaixaCirurgica = false
    this.showModalQuantidade = false
  }

  @Watch('showModalCaixaCirurgica')
  onChangeShowModalCaixaCirurgica(value: boolean) {
    setTimeout(() => {
      const input = document.querySelector('.caixa-cirurgica-input input') as HTMLInputElement
      this.getInputSearch = ''
      if (value) {
        input.focus()
      } else {
        input.blur()
        this.getBackofficeGlobalStore.clearCaixasCirurgicasApi()
      }
    }, 100)
  }

  @Watch('showModalQuantidade')
  onChangeShowModalQuantidade(value: boolean) {
    if (!value) {
      this.caixaCirurgica = null
    }
  }
}
